import {
  type KeyCloakUser,
  getUserInfos,
} from "@shared/services/userManagementKeyCloak";
import { defineStore } from "pinia";
import { ref } from "vue";
import {
  type LoadState,
  stateLoaded,
  stateLoading,
  stateError,
} from "../models/state";

export const useUserInformationStore = defineStore("userInformation", () => {
  const userInformationCache = ref<Map<string, LoadState<KeyCloakUser>>>(
    new Map(),
  );

  async function loadUserInformation(ids: string[]) {
    // remove users that are already loaded or loading
    const usersToLoad = ids.filter((id) => !userInformationCache.value.has(id));
    if (usersToLoad.length === 0) {
      return;
    }
    usersToLoad.forEach((id) =>
      userInformationCache.value.set(id, { ...stateLoading }),
    );
    await getUserInfos(usersToLoad).then(
      (response) => {
        response.data.result.forEach((user) =>
          userInformationCache.value.set(user.id, {
            ...stateLoaded,
            result: user,
          }),
        );
      },
      (error) => {
        ids.forEach((id) =>
          userInformationCache.value.set(id, { ...stateError }),
        );
      },
    );
  }

  return {
    userInformationCache,
    loadUserInformation,
  };
});
